import * as Yup from "yup";

//   validation form
export const validationSchema = Yup.object({
    Phone: Yup.string().required("پر کردن این فیلد ضروری است"),
    password: Yup.string().required("پر کردن این فیلد ضروری است"),
});